import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Uuele liitujale 500 € ON24 raha kätte.

  <span style="color:#85c1dc;">**FI:**</span>
  Uudelle liittyjälle 500 €.

  <span style="color:#85c1dc;">**RU:**</span>
  Новым подписчикам 500 €.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1508 = msg(
  mf`Uuele liitujale 500 € ON24 raha kätte.`,
  mf`Uudelle liittyjälle 500 €.`,
  mf`Новым подписчикам 500 €.`,
)

export { m1508 as 'w.module.cta_banner.title' }